import React from 'react';

import { Copyright, FooterContainer } from './styled';

const Footer = () => (
	<FooterContainer>
		<div className='mx-auto text-center'>
			<Copyright>Copyright &#169; {new Date().getFullYear()}</Copyright>
		</div>
		{/* <LinkContainer to={pageurl.OVERVIEW}>
        <Logo src={dai} />
      </LinkContainer> */}
	</FooterContainer>
);

export default Footer;
